export const PostalCodeUpper = 'postal_code_upper'
export const PostalCodeLower = 'postal_code_lower'
export const StateOrPrefecture = 'stateOrPrefecture'
export const City = 'city'
export const Street = 'street'
export const Building = 'building'
